export const fliggyOfflineFormCheck = {
  surname(value) {
    return !value || !/^[\u4e00-\u9fa5]+$/.test(value);
  },
  given_name(value) {
    return !value || !/^[\u4e00-\u9fa5]+$/.test(value);
  },
  surname_pinyin(value) {
    return !value || value.length < 2 || !/^[A-Z]+$/.test(value);
  },
  given_name_pinyin(value) {
    return !value || value.length < 2 || !/^[A-Z]+$/.test(value);
  },
  credential_no(value) {
    return !value || value.length !== 9 || !/^[A-Z0-9]+$/.test(value);
  },
  identity_id(value) {
    return value === undefined;
  },
};



// WEBPACK FOOTER //
// ./src/components/add-order/created-order/components/ota/fliggy-offline-form-check.js